module.exports = __webpack_public_path__ + "static/media/52.0d212a8e.png";